export default __webpack_public_path__ + "61fb04a18a21b964cbbb67119d6d3d72.png";